import { request } from '@mirai/data-sources';

const EVENT_SOURCE_URL_EVENTS = ['Purchase', 'Search', 'InitiateCheckout', 'AddToCart'];

export const sendData = async (data) =>
  request({
    endpoint: '/tracking/facebook/track',
    hostname: process.env.SERVICE_CURRENCY,
    method: 'POST',
    ...(EVENT_SOURCE_URL_EVENTS.includes(data.eventName)
      ? { eventSourceUrl: `${document.location.origin}${document.location.pathname}` }
      : undefined),
    ...data,
  });
